// tslint:disable-next-line:max-line-length
export const licensingPageXml = ' <w:p xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main">\n' +
  '      <w:r>\n' +
  '        <w:lastRenderedPageBreak/>\n' +
  '        <w:drawing>\n' +
  '          <wp:inline distT="0" distB="0" distL="0" distR="0">\n' +
  '            <wp:extent cx="3781425" cy="1334030"/>\n' +
  '            <wp:docPr id="1" name="Grafik 2"/>\n' +
  '            <wp:cNvGraphicFramePr>\n' +
  '              <a:graphicFrameLocks xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" noChangeAspect="1"/>\n' +
  '            </wp:cNvGraphicFramePr>\n' +
  '            <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">\n' +
  '              <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">\n' +
  '                <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">\n' +
  '                  <pic:nvPicPr>\n' +
  '                    <pic:cNvPr id="0" name="Picture 1"/>\n' +
  '                    <pic:cNvPicPr>\n' +
  '                      <a:picLocks noChangeAspect="1" noChangeArrowheads="1"/>\n' +
  '                    </pic:cNvPicPr>\n' +
  '                  </pic:nvPicPr>\n' +
  '                  <pic:blipFill>\n' +
  '                    <a:blip r:embed="__REPLACE__" cstate="print">\n' +
  '                    </a:blip>\n' +
  '                    <a:stretch>\n' +
  '                      <a:fillRect/>\n' +
  '                    </a:stretch>\n' +
  '                  </pic:blipFill>\n' +
  '                  <pic:spPr bwMode="auto">\n' +
  '                    <a:xfrm>\n' +
  '                      <a:off x="0" y="0"/>\n' +
  '                      <a:ext cx="3959088" cy="1396707"/>\n' +
  '                    </a:xfrm>\n' +
  '                    <a:prstGeom prst="rect">\n' +
  '                      <a:avLst/>\n' +
  '                    </a:prstGeom>\n' +
  '                    <a:noFill/>\n' +
  '                    <a:ln>\n' +
  '                      <a:noFill/>\n' +
  '                    </a:ln>\n' +
  '                  </pic:spPr>\n' +
  '                </pic:pic>\n' +
  '              </a:graphicData>\n' +
  '            </a:graphic>\n' +
  '          </wp:inline>\n' +
  '        </w:drawing>\n' +
  '      </w:r>\n' +
  '    </w:p>';
